// @ts-nocheck
import { getCurrentCustomerType, getIsB2BCustomer } from "@store/Framework/Store/Data/BillTos/BillTosSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useCurrentCustomerType = convertSelectorToHook(getCurrentCustomerType);
export const useIsB2BCustomer = convertSelectorToHook(getIsB2BCustomer);
